import cls from './nav-divider.module.scss'
import createSimpleComponent from '../createSimpleComponent'

export default createSimpleComponent({
  displayName: 'TopBarMenuDivider',
  className: cls.wrapper,
  Component: 'div',
})
